import { Box, Typography } from '@mui/material';
import { useEffect, useState } from 'react';
import logo from './assets/logo/logo.png';

const SplashScreen = () => {
    const [visible, setVisible] = useState(true);
    const [animateOut, setAnimateOut] = useState(false);

    useEffect(() => {
        const timer = setTimeout(() => {
            setAnimateOut(true);
            setTimeout(() => setVisible(false), 800);
        }, 2800);

        return () => clearTimeout(timer);
    }, []);

    if (!visible) return null;

    return (
        <Box
            sx={{
                position: 'fixed',
                top: 0,
                left: 0,
                pl: 2,
                width: '100vw',
                height: '100vh',
                bgcolor: "#4444449f",
                backdropFilter: "blur(8px)",
                color: 'white',
                display: 'flex',
                flexDirection: 'column',
                justifyContent: 'center',
                alignItems: 'center',
                zIndex: 1300,
                animation: animateOut ? 'fadeOutScale 0.3s ease-in forwards' : 'none',
                '@keyframes fadeOutScale': {
                    from: { transform: 'scale(1)', opacity: 1 },
                    to: { transform: 'scale(0.5)', opacity: 0 },
                },
            }}
        >
            <Box
                display="flex"
                flexDirection="column"
                position="relative"
                width="100%"
                alignItems="center"
            >
                <Box
                    component="img"
                    src={logo}
                    alt="Enduro logo"
                    sx={{
                        width: { xs: 280, sm: 460 },
                        // height: { xs: 96, sm: 120 },
                        objectFit: "contain",
                        mb: 2,
                        opacity: 0,
                        animation: 'logoFade 0.5s ease-out forwards, logoFloat 2.4s ease-in-out 0.6s infinite',
                        filter: "drop-shadow(0 10px 18px rgba(0,0,0,0.45))",
                    }}
                />
                <Typography
                    color="#d8d1d1"
                    fontFamily="Titan One"
                    fontWeight={600}
                    variant="h4"
                    sx={{
                        textShadow: "#000000 0px 0px 4px",
                        opacity: 0,
                        animation: 'dropIn 0.3s ease-out forwards',
                        animationDelay: '200ms',
                    }}
                >
                    Enduro Connection
                </Typography>

                <Typography
                    color="#fff"
                    fontFamily="Titan One"
                    variant="h1"
                    sx={{
                        textShadow: "#000000 1px 0 10px",
                        opacity: 0,
                        animation: 'dropIn 0.3s ease-out forwards',
                        animationDelay: '800ms',
                    }}
                >
                    Raduša
                </Typography>

                <Typography
                    mt={0.5}
                    color="#d8d1db"
                    fontFamily="Titan One"
                    fontStyle="italic"
                    sx={{
                        textShadow: "#000000 1px 0 6px",
                        opacity: 0,
                        animation: 'dropIn 0.3s ease-out forwards',
                        animationDelay: '1400ms',
                    }}
                >
                    by Ivan Rezo
                </Typography>
            </Box>

            <style>
                {`
          @keyframes dropIn {
            from {
              transform: translateY(-100px);
              opacity: 0;
            }
            to {
              transform: translateY(0);
              opacity: 1;
            }
          }

          @keyframes logoFade {
            from { opacity: 0; }
            to { opacity: 1; }
          }

          @keyframes logoFloat {
            0% { transform: translateY(0); }
            50% { transform: translateY(-8px); }
            100% { transform: translateY(0); }
          }
        `}
            </style>
        </Box>
    );
};

export default SplashScreen;
